export { default } from './GlobalStyles';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/GlobalStyles/index.js
// module id = 322
// module chunks = 25